import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import CardContainerUniDriver from '../CardContainer/CardContainer.uni.driver';

export default (base: UniDriver, body: UniDriver) => {
  return CardContainerUniDriver(base, body);
};
